import { Config } from "../core/config/config";
import { ComponentHelper } from "../core/util/componentHelper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ReportMetaDataContext, ApplicationCriteria } from "./reportMetaData";
import { ToolBar } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { HTTPService } from "../core/util/httpManager";
import { DropDownList } from "../core/components/dropDownList";
import { Helper } from "../core/util/helper";
import { FieldInstance } from "../core/components/field";
import { Label } from "../core/components/label";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import React from "react"
export default class ApplicationCriteriaGrid extends React.Component<ApplicationCriteriaGridProps, ApplicationCriteriaGridState>{
    private dialogRef: ApplicationCriteriaDialog;
    private factory = ComponentHelper.createFactory();
    private gridOptions: kendo.ui.GridOptions;
    private apps: App[];
    private environments: Environment[];
    constructor(props: ApplicationCriteriaGridProps) {
        super(props);
        this.initApp();
        this.state = {
            gridData: [],
            selectedItem: null
        }
    }

    private setGridData = (gridData: GridItem[], isInit: boolean = false) => {
        let index: number;
        //implizite werden ausgeblendet wenn es explizite gibt
        for (let i = 0; i < gridData.length; i++) {
            if (gridData[i].Implied) {
                index = gridData.findIndex(f => f.AppId === gridData[i].AppId && f.EnviromentId === gridData[i].EnviromentId && !f.Implied);
                gridData[i].Visible = (index === -1);
            }
        }
        let count = 0;
        for (let i = 0; i < gridData.length; i++) {
            if (!gridData[i].Implied) {
                count = gridData.filter(f => f.ImpliedBy === gridData[i].GridId).length;
                if (count > 0) { // hat kinder
                    count = gridData.filter(f => f.ImpliedBy === gridData[i].GridId && f.Visible).length;
                    gridData[i].Visible = (count > 0);
                } else { // hat keine Kinder
                    gridData[i].Visible = true;
                }
            }
        }
        this.setState({ gridData: gridData }, () => {
            if (!this.props.disabled && !isInit) {
                let value: ApplicationCriteria[] = this.state.gridData.filter(f => !f.Implied).map((item) => {
                    let criteria: ApplicationCriteria = {
                        ApplicationId: (item.AppId > 0) ? item.AppId : null,
                        ExecutionEnvironmentId: (item.AppId > 0) ? null : item.EnviromentId
                    };
                    return criteria;
                });
                let result: ApplicationCriteria[] = value.filter((value: ApplicationCriteria, index: number, self: ApplicationCriteria[]) => {
                    return self.findIndex(f => f.ApplicationId == value.ApplicationId && f.ExecutionEnvironmentId == value.ExecutionEnvironmentId) === index;
                });
                this.props.onChange(this.props.field, result);
            }
        });
    }

    private initApp = () => {
        this.apps = [
            {
                Environment: null,
                WellKnownApplication: null,
                Name: this.props.context.translations["Standard.Alle"],
                Id: 0,
            }
        ]; 
        this.gridOptions = {
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "EnviromentName",
                    title: this.props.context.translations["WebSMS.ReportMetadata.Environment"]
                },
                {
                    field: "AppName",
                    title: this.props.context.translations["WebSMS.ReportMetadata.App"]
                }
            ]
        };

        HTTPService.chainBatch
            .add<App[]>("ReportMetaData/GetAllApps")
            .add<Environment[]>("ReportMetaData/GetAllEnvironments")          
            .promise()
            .then(result => {
                this.apps = this.apps.concat(result[0]);
                this.environments = result[1];
                let gridData: GridItem[] = [];
                this.props.value.filter(f => Helper.hasValue(f.ExecutionEnvironmentId) && !Helper.hasValue(f.ApplicationId)).forEach((item) => {
                    let gridId = kendo.guid();
                    let gridItem: GridItem = {
                        AppId: 0,
                        AppName: this.props.context.translations["Standard.Alle"],
                        EnviromentId: item.ExecutionEnvironmentId,
                        EnviromentName: this.environments.find(f => f.Id === item.ExecutionEnvironmentId).Name,
                        GridId: gridId,
                        Implied: false,
                        ImpliedBy: null,
                        Visible: true
                    };
                    gridData.push(gridItem);
                    this.apps.filter(f => f.Environment === item.ExecutionEnvironmentId).forEach((app) => {
                        let gridItem: GridItem = {
                            AppId: app.Id,
                            AppName: app.Name,
                            EnviromentId: item.ExecutionEnvironmentId,
                            EnviromentName: this.environments.find(f => f.Id === item.ExecutionEnvironmentId).Name,
                            GridId: kendo.guid(),
                            Implied: true,
                            ImpliedBy: gridId,
                            Visible: true
                        };
                        gridData.push(gridItem);
                    });
                });
                this.props.value.filter(f => !Helper.hasValue(f.ExecutionEnvironmentId) && Helper.hasValue(f.ApplicationId)).forEach((item) => {
                    let app = this.apps.find(f => f.Id === item.ApplicationId);
                    let gridItem: GridItem = {
                        AppId: item.ApplicationId,
                        AppName: app.Name,
                        EnviromentId: app.Environment,
                        EnviromentName: this.environments.find(f => f.Id === app.Environment).Name,
                        GridId: kendo.guid(),
                        Implied: false,
                        ImpliedBy: null,
                        Visible: true
                    };
                    gridData.push(gridItem);
                });
                this.setGridData(gridData, true);
            });
    }

    //grid
    private createToolBar = () => {
        let customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "k-i-plus", id: "add" },
            { caption: Config.translations.delete, enabled: Helper.hasValue(this.state.selectedItem) && !this.state.selectedItem.Implied, iconClass: "k-i-close", id: "remove" }
        ];
        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton} />
            </>
        );
    }

    private handleClickCustomButton = (id: string) => {
        switch (id) {
            case "add":
                this.dialogRef.openDialog();
                break;
            case "remove":
                this.delete();
                break;
        }
    }

    private delete = () => {
        let lst = this.state.gridData.filter(f => f.ImpliedBy === this.state.selectedItem.GridId).map(f => { return f.GridId });
        lst.push(this.state.selectedItem.GridId);
        let gridData = this.state.gridData.filter(f1 => lst.findIndex(f2 => f1.GridId === f2) === -1);
        this.setGridData(gridData);
    }

    private createGrid = () => {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData.filter(f => f.Visible)}
                    options={this.gridOptions}
                    id="applicationCriteriaGrid"
                    onSelectionChanged={(item: GridItem) => {
                        this.setState({ selectedItem: item });
                    }}
                    onDataBound={this.handleDataBound}
                />
            </div>
        );
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (let i = 0; i < data.length; i++) {
            if (data[i].Implied) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("color", "#bdbdbd");
                cell.prop('title', this.props.context.translations["WebSMS.ReportMetadata.AddedImplicitly"]);
            } else if (this.state.gridData.filter(f => f.ImpliedBy === data[i].GridId).length > 0) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", "#bdbdbd");
                cell.prop('title', this.props.context.translations["WebSMS.ReportMetadata.AddsCriterias"]);
            }
        }
    }

    private createReplacmentText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className="fal fa-desktop-alt fa-10x" style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.props.context.translations["WebSMS.ReportMetadata.ForAllApps"]}
                    </label>
                </div>
            </div>
        );
    }

    //dialog
    private createDialog = () => {
        return (
            <>
                <ApplicationCriteriaDialog
                    ref={this.setRef}
                    onOk={this.onOk}
                    translation={this.props.context.translations}
                    apps={this.apps}
                    environments={this.environments}
                />
            </>
            );
    }

    private setRef = (ref: ApplicationCriteriaDialog) => {
        this.dialogRef = ref
    }

    private onOk = (gridData: GridItem[]) => {
        let lst: GridItem[] = JSON.parse(JSON.stringify(this.state.gridData));
        for (let i = 0; i < gridData.length; i++) {
            lst.push(gridData[i]);
        }
        this.setGridData(lst);
    }

    render() {
        const dialog = this.createDialog();
        const grid = (this.state.gridData.length > 0) ? this.createGrid() : this.createReplacmentText();
        const toolBar = !this.props.disabled ? this.createToolBar() : null;
        return (
            <>
                {toolBar}
                {grid}
                {dialog}
            </>
        );
    }
}

interface ApplicationCriteriaGridProps extends BaseComponentProps {
    context: ReportMetaDataContext;
    value: ApplicationCriteria[];
}

interface ApplicationCriteriaGridState{
    gridData: GridItem[];
    selectedItem: GridItem; 
}

class ApplicationCriteriaDialog extends React.Component<ApplicationCriteriaDialogProps, ApplicationCriteriaDialogState>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    let apps: App[] = []; 
                    let gridId: string = null;
                    let gridData: GridItem[] = [];
                    if (this.state.app.Id === 0) {
                        gridId = kendo.guid();
                        apps = this.props.apps.filter(f => f.Id > 0 && f.Environment == this.state.environment.Id);
                        gridData.push({ AppId: this.state.app.Id, AppName: this.state.app.Name, EnviromentId: this.state.environment.Id, EnviromentName: this.state.environment.Name, GridId: gridId, Implied: false, ImpliedBy: null, Visible: true })
                    } else {
                        apps = [this.state.app];
                    }

                    apps.forEach((app: App) => {
                        let gridItem: GridItem = {
                            AppId: app.Id,
                            AppName: app.Name,
                            EnviromentId: this.state.environment.Id,
                            EnviromentName: this.state.environment.Name,
                            GridId: kendo.guid(),
                            Implied: !Helper.isNullOrEmpty(gridId),
                            ImpliedBy: gridId,
                            Visible: true
                        }
                        gridData.push(gridItem);
                    });
                    this.props.onOk(gridData)
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false })
        },
        width: 500
    };
    constructor(props) {
        super(props);
        this.state = {
            app: null,
            dialogOpen: false,
            environment: null,
        };
        this.initApp();
    }



    private initApp = () => {
        this.dialogProps.title = this.props.translation["Standard.Auswählen"];
    }

    openDialog = () => {
        this.setState({ dialogOpen: true, environment: null, app: null });
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createEnvironmentDropDownList()}
                    {Helper.hasValue(this.state.environment) ? this.createAppDropDownList() : null}
                </Dialog>
            </>
        );
    }

    private createEnvironmentDropDownList = () => {
        let props = this.factory.getDefaultDropDownProps();

        props.dataSource = this.copy(this.props.environments);
        props.value = Helper.hasValue(this.state.environment) ? this.state.environment.Id : null;
        props.onChange = (field, value, model) => {
            this.setState({ environment: model, app: this.props.apps[0] });
        }
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.refreshDSOnRefChange = true;
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 250px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td></tr></table>";

        return (
            <>
                <FieldInstance label={this.props.translation["WebSMS.ReportMetadata.Environment"]}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private createAppDropDownList = () => {
        let props = this.factory.getDefaultDropDownProps();

        let dataSource = this.props.apps.filter(f => f.Environment == null || f.Environment === this.state.environment.Id);

        props.dataSource = dataSource;
        props.value = Helper.hasValue(this.state.app) ? this.state.app.Id : null;
        props.onChange = (field, value, model) => {
            this.setState({ app: model });
        }
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.optionLabel = "";
        props.field.refreshDSOnRefChange = true;
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 250px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td></tr></table>";

        return (
            <>
                <FieldInstance label={this.props.translation["WebSMS.ReportMetadata.App"]}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private copy = (item) => {
        return (JSON.parse(JSON.stringify(item)))
    }

    render() {
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return <>{dialog}</>;
    }
}

interface ApplicationCriteriaDialogProps {
    translation: {};
    onOk: (gridData: GridItem[]) => void;
    apps: App[];
    environments: Environment[];
} 

interface ApplicationCriteriaDialogState {
    dialogOpen: boolean;
    environment: Environment;
    app: App;
}

interface GridItem {
    GridId: string;//Guid
    AppId: number;
    EnviromentId: number;
    AppName: string;
    EnviromentName: string;
    Implied: boolean;
    ImpliedBy: string; //Verweis auf GridId
    Visible: boolean;
}

interface Environment {
    Id: number;
    Name: string;
    WellKnownExecutionEnvironment: WellKnownExecutionEnvironment;
}
interface App {
    Id: number;
    Name: string;
    WellKnownApplication: WellKnownApplication;
    Environment: number;
}

enum WellKnownApplication {
    MobileApp = 1,
    Dgf = 2,
    Fsm = 3
}

enum WellKnownExecutionEnvironment {
    MainOffice = 1,
    FieldService = 2
}